export default "__VITE_ASSET__BQWNlz7i__"